import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información médica", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-ips"
}, "Nombre IPS", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-headquarter"
}, "Sede de atención", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-policy"
}, "Número de póliza de seguro", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-bloodtype"
}, "Tipo de sangre", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-allergies"
}, "Alergias", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-chronic"
}, "Enfermedades crónicas", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-meds"
}, "Medicamentos", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-emerg"
}, "Instrucciones de emergencia", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Es un niño PIAR", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "input-ips",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.NameIps,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('NameIps', val)),
                  placeholder: "Ingrese el nombre de la IPS",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "input-headquarter",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.AttentionHeadquarter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('AttentionHeadquarter', val)),
                  placeholder: "Ingrese la sede de atención",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "input-policy",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.InsurancePolicyNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('InsurancePolicyNumber', val)),
                  placeholder: "Ingrese el número de póliza",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "input-bloodtype",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.BloodType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('BloodType', val)),
                  placeholder: "Ingrese el tipo de sangre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_textarea, {
                  id: "input-allergies",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Allergies,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('Allergies', val)),
                  placeholder: "Liste las alergias",
                  rows: "3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_b_form_textarea, {
                  id: "input-chronic",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ChronicDiseases,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('ChronicDiseases', val)),
                  placeholder: "Liste las enfermedades crónicas",
                  rows: "3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_b_form_textarea, {
                  id: "input-meds",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Medications,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('Medications', val)),
                  placeholder: "Liste los medicamentos",
                  rows: "3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_b_form_textarea, {
                  id: "input-emerg",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.EmergencyInstructions,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('EmergencyInstructions', val)),
                  placeholder: "Ingrese las instrucciones de emergencia",
                  rows: "3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.ReceivesSchoolMeals,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('ReceivesSchoolMeals', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Recibe alimentación escolar ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.IsPIAR,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('IsPIAR', !!val))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}